module.exports = __webpack_public_path__ + "img/allottee3_7-8-2021.5cf3a039.jpg";